import { ChartEditorError } from './types';

export const CHART_EDITOR_ERRORS: Record<ChartEditorError, string> = {
  [ChartEditorError.WIDGET]: 'chart_widget_editor.widget_error',
};
